module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-create-technicians/master-create-technicians.component.scss
// module id = ./src/app/master/master-create-technicians/master-create-technicians.component.scss
// module chunks = main